/**
 * @form
 */
function changeActiveClass(el) {
    const value = el.value;

    if (value.length > 0) {
        el.parentNode.classList.add(`is-changed`);
    } else {
        el.parentNode.classList.remove(`is-changed`);
    }
}
/**
 * Init form decoration label
 */
export const initForm = () => {
    const inputs = document.querySelectorAll(`[data-input] input:not([type="hidden"])`);

    inputs.forEach((input) => {
        changeActiveClass(input);

        input.onfocus = function() {
            changeActiveClass(this);
        };

        input.onblur = function() {
            changeActiveClass(this);
        };

        input.oninput = function() {
            changeActiveClass(this);
        }
    });
};
